// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_zJZkR","column":"index_column_YP2-9","banner":"index_banner_6nKLa","columnLeft":"index_columnLeft_GzoWZ","columnRight":"index_columnRight_LdAiX"};